import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { OverDeliveryPartLoadPartData } from '@/api/OverDeliveryPart';
export default {
  name: 'SpareTable',
  data: function data() {
    return {
      formData: {
        Page: 1,
        Limit: 15,
        CODE: '',
        NAME: ''
      },
      tableLoading: false,
      tableData: [],
      totalPage: 0
    };
  },
  created: function created() {
    this.searchPartList();
  },
  methods: {
    searchPartList: function searchPartList() {
      this.formData.Page = 1;
      this.getSparePartDate();
    },
    getSparePartDate: function getSparePartDate() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$formData, Page, Limit, CODE, NAME, params, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.tableLoading = true;
                _this$formData = _this.formData, Page = _this$formData.Page, Limit = _this$formData.Limit, CODE = _this$formData.CODE, NAME = _this$formData.NAME;
                params = {
                  Page: Page,
                  Limit: Limit,
                  CODE: CODE,
                  NAME: NAME
                };
                _context.next = 5;
                return OverDeliveryPartLoadPartData(params);

              case 5:
                res = _context.sent;

                if (res.code === 0) {
                  _this.tableData = res.data.Items;
                  _this.totalPage = res.data.TotalCount;
                }

                _this.tableLoading = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    cellInsertClick: function cellInsertClick(row) {
      this.$emit('cell-insert-click', row);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.Limit = val;
      this.getSparePartDate();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.formData.Page = val;
      this.getSparePartDate();
    }
  }
};